import { Link } from "office-ui-fabric-react"

const TimeTrackingBillableSettingsTooltip = () => {
    return <span>
        Manage the synchronization rules of the Billable and Cost Type fields values to the time
        entries recorded by users. Please refer to the <Link
            target="_blank"
            href="https://help.ppm.express/89495-ppm-express-settings/2610325-time-tracking-settings#section-2">
            article 
        </Link> for more details.
    </span>
}

export default TimeTrackingBillableSettingsTooltip;